export default [
  {
    title: "유해화학물질",
    list: [
      {
        content: "1. 락스, 세척제 등 취급하는 유해화학물질의 유해성·위험성, 노출 시 조치방법 등 관리방안과 제공받은 MSDS*를 근로자에게 교육한다.\n* 「생활화학제품 및 살생물제의 안전관리에 관한 법률」에 따른 안전확인대상 생활화학제품 및 살생물제품 중 일반소비자의 생활용으로 제공되는 제품의 MSDS는 제외",
        isChecked: "",
      },
      {
        content: "2. 유해화학물질을 화기나 그 밖에 점화원이 될 우려가 있는 것에 접근, 가열, 마찰시키는 등의 행위를 하지 않는다.",
        isChecked: "",
      },
      {
        content: "3. 유해화학물질 용기(소분용기포함)에 시 물질명, 경고표시 등 내용물에 대한 주의사항을 명확히 표기하였다.",
        isChecked: "",
      },
      {
        content: "4. 근로자에게 적절한 방호조치 및 개인보호구 지급·착용토록 관리한다.",
        isChecked: "",
      },
      {
        content: "5. 유해화학물질을 취급하는 곳에 응급 시 근로자가 쉽게 사용할 수 있도록 세척시설과 세안설비를 설치하고 있다.",
        isChecked: "",
      },
      {
        content: "6. LPG가스 등 인화성물질에 의한 화재·폭발·누출을 미리 감지하기 위한 가스 검지 및 경보장치가 설치되어 있다.",
        isChecked: "",
      },
      {
        content: "7. 배관 연결부, 밸브 등의 연결부에서 물질의 누출 여부를 정기적으로 점검한다.",
        isChecked: "",
      },
      {
        content: "8. 가스경보기가 작동할 경우 조치사항을 근로자에게 교육한다.",
        isChecked: "",
      },
      {
        content: "9. 유해화학물질의 성상에 따라 저장구역을 구분하여 관리한다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "소음 또는 진동",
    list: [
      {
        content: "1. 사업장의 소음 또는 진동 발생 장소·설비 등에 대해 분류하고 있다.",
        isChecked: "",
      },
      {
        content: "2. 사업장에서는 소음 또는 진동에 의한 유해성·위험성 및 관리방안을 근로자에게 주지시키고 있다.",
        isChecked: "",
      },
      {
        content: "3. 작업환경측정을 통해 노출되는 소음 또는 진동의 노출수준을 확인한다.",
        isChecked: "",
      },
      {
        content: "4. 작업환경측정 결과에 따라 노출수준 저감을 위한 관리방안*을 마련하고 있다.\n* 노출시간 제한, 소음·진동 저감을 위한 보조기구 사용 등",
        isChecked: "",
      },
      {
        content: "5. 소음 또는 진동 발생 작업에 근로자를 배치하기 전 근로자의 건강상태와 특성 등을 고려하여 배치하고 있다.",
        isChecked: "",
      },
      {
        content: "6. 정기적인 건강진단(평가) 결과를 토대로 상담, 의학적 처치 등이 적절히 조치하였다.",
        isChecked: "",
      },
      {
        content: "7. 적절한 청력·진동보호구를 지급하고, 근로자에게 착용법을 교육한다.",
        isChecked: "",
      },
      {
        content: "8. 85dB 이상 소음이 발생하는 작업을 포함하여 청력보존프로그램*을 수립·시행하고 있다.\n* 청력보존 프로그램 시행 대상(안전보건규칙 제517조) ①작업환경측정 결과 90dB 초과하는 사업장 ②소음으로 인한 근로자 건강장해 발생 사업장",
        isChecked: "",
      },
      {
        content: "9. 청력보호가 필요한 곳*에 경고판을 부착하였다.\n* 배기후드, 식품가공기기, 조리기기, 식기세척기 등의 소음이 1일 8시간 기준 85dB 이상 발생하는 장소",
        isChecked: "",
      },
    ],
  },
  {
    title: "고열·한랭",
    list: [
      {
        content: "1. 사업장에서 열원이 발생하거나 취급하는 장소·설비를 파악한다.",
        isChecked: "",
      },
      {
        content: "2. 사업장에서 고열(한랭)의 유해성·위험성 및 관리방안을 근로자에게 주지시키고 있다.",
        isChecked: "",
      },
      {
        content: "3. 작업환경측정 등을 통해 근로자에게 노출되는 고열(한랭) 노출수준을 관리하고 있다.",
        isChecked: "",
      },
      {
        content: "4. 측정결과에 따라 적정한 관리방안*을 마련하고 있다.\n* 열원 격리, 작업장 내 온·습도 조절장치 비치 등",
        isChecked: "",
      },
      {
        content: "5. 근로자의 건강상태와 특성 등을 고려하여 배치하고 있다.",
        isChecked: "",
      },
      {
        content: "6. 작업의 강도에 따른 휴식시간을 적절히 부여하고, 쾌적한 휴게공간을 제공하고 있다.",
        isChecked: "",
      },
      {
        content: "7. 냉동․냉장창고의 출입문이 임의로 잠기지 않도록 조치하고, 내부에서 수동개폐가 가능한 구조로 설치되어 있다.",
        isChecked: "",
      },
      {
        content: "8. 냉동․냉장창고의 온도, 예상작업시간을 사전에 파악하고 창고 내 작업 중인 근로자와 수시로 연락하여 작업상황을 공유한다.",
        isChecked: "",
      },
      {
        content: "9. 고열 또는 한랭 작업 등을 하는 근로자에게 적절한 보호구를 지급하고 착용하도록 관리하고 있다.",
        isChecked: "",
      },
      {
        content: "10. 한랭으로 인한 건강장해(저체온증 등) 발생 시 대응절차 등을 마련하고 시행하고 있다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "근골격계질환",
    list: [
      {
        content: "1. 근골격계질환이 발생할 수 있는 위험요인과 작업을 파악하고 있다.",
        isChecked: "",
      },
      {
        content: "2. 근골격계질환 유해요인조사를 실시하고, 그 결과를 근로자에게 공유한다.",
        isChecked: "",
      },
      {
        content: "3. 근골격계질환 발생 우려가 있는 경우 인간공학적 설계, 인력작업 보조설비 및 편의설비를 설치하고 있다.",
        isChecked: "",
      },
      {
        content: "4. 유해요인, 징후와 증상, 대처 요령, 올바른 작업자세, 작업도구, 작업시설의 올바른 사용법을 근로자에게 교육한다.",
        isChecked: "",
      },
      {
        content: "5. 취급 물품의 중량, 취급빈도, 운반거리, 운반 속도 등 작업조건에 따라 작업시간 및 휴식시간 등을 적정하게 배분하고 있다.",
        isChecked: "",
      },
      {
        content: "6. 중량물의 중량과 무게중심을 표시하고 손잡이를 붙이거나 갈고리, 진공빨판 등을 활용하고 있다.",
        isChecked: "",
      },
      {
        content: "7. 서서 일하는 근로자 또는 VDT 작업자에게 적절한 작업대 등의 작업환경을 제공하고 있다.",
        isChecked: "",
      },
      {
        content: "8. 근골격계 질환 예방을 위한 프로그램을 운영하고 있다.",
        isChecked: "",
      },
      {
        content: "9. 근로자가 편히 쉴 수 있는 휴게공간과 휴식시간을 부여한다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "근로자 건강관리",
    list: [
      {
        content: "1. 근로자의 건강을 보호하고, 증진시키기 위한 조직과 체계가 마련되어 있다.",
        isChecked: "",
      },
      {
        content: "2. 우리 사업장(현장)에서 보유하고 있는 건강진단 대상 유해인자에 대해 관리하고 있다.",
        isChecked: "",
      },
      {
        content: "3. 건강진단 대상 유해인자에 노출되고 있는 작업과 근로자를 파악하고 있다.",
        isChecked: "",
      },
      {
        content: "4. 근로자의 건강보호 유지를 위하여 정기적인 건강진단을 실시하고 있다.",
        isChecked: "",
      },
      {
        content: "5. 건강진단 결과에 따른 사후조치를 실시하고 있다.",
        isChecked: "",
      },
      {
        content: "6. 근로자 개인별 건강관리를 위한 상담을 실시하고 이력을 관리하고 있다.",
        isChecked: "",
      },
      {
        content: "7. 근로자의 작업 배치 시 근로자 개인의 특성과 건강상태 등을 고려하여 작업에 배치하였다.",
        isChecked: "",
      },
      {
        content: "8. 근로자가 편히 쉴 수 있는 휴게공간과 휴식시간을 부여한다.",
        isChecked: "",
      },
      {
        content: "9. 작업장의 조도와 온·습도는 적절히 유지되고 있다.",
        isChecked: "",
      },
      {
        content: "10. 근로자의 건강관리능력을 함양하기 위한 건강증진 프로그램 등 건강증진사업을 시행하고 있다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "응급조치",
    list: [
      {
        content: "1. 응급상황 발생 시 대응체계를 구축하고 있다.",
        isChecked: "",
      },
      {
        content: "2. 응급상황 발생을 관리할 수 있는 조직을 구성하고 그 직무를 규정하고 있다.",
        isChecked: "",
      },
      {
        content: "3. 응급상황 발생 시 연락대응 체계를 구축하고 비상연락망을 유지하고 있다.",
        isChecked: "",
      },
      {
        content: "4. 응급상황 발생 시 근로자들은 신고체계와 보고체계에 대해 숙지하고 있다.",
        isChecked: "",
      },
      {
        content: "5. 응급상황 발생 시 대응할 수 있는 소화기, 응급 처치함, 구조장비 등 비상 물품을 구비하고 있다.",
        isChecked: "",
      },
      {
        content: "6. 응급상황에 대비한 훈련을 정기적으로 실시하고 평가하고 있다.",
        isChecked: "",
      },
      {
        content: "7. 응급상황이 완료된 후 이를 기록하고 관리하고 있다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "이륜차",
    list: [
      {
        content: "1. 사용신고필증, 등록번호판 구비 및 보험에 가입되어 있다.",
        isChecked: "",
      },
      {
        content: "2. 전조등, 제동등, 후미등, 후사경 또는 제동장치는 모두 정상적으로 작동한다.",
        isChecked: "",
      },
      {
        content: "3. 1년마다 정기적으로 안전점검을 받는다.",
        isChecked: "",
      },
      {
        content: "4. 이륜차 면허증 미소지자는 이륜차 운행을 금지한다.",
        isChecked: "",
      },
      {
        content: "5. 운행 전 핸들, 타이어, 머플러 등에 이상이 없는지 확인한다.",
        isChecked: "",
      },
      {
        content: "6. 이륜차를 운행하는 근로자에게 승차용 안전모를 지급하여 착용토록 하고 있다.",
        isChecked: "",
      },
      {
        content: "7. 이륜차를 운행하는 근로자가 음주, 과로 시 운전을 금지한다.",
        isChecked: "",
      },
      {
        content: "8. 이륜차에 물건을 적재 시 편하중·떨어짐 방지조치를 실시한다.",
        isChecked: "",
      },
      {
        content: "9. 날씨에 따른 운행 시 주의사항, 위험요인, 감속기준 등을 제시하고 필요시 운행을 제한하는 절차를 가지고 있다.",
        isChecked: "",
      },
      {
        content: "10. 배달종사자에게 배달지역의 지리적 특성(과속방지턱, 급커브 구역 등)과 노면상태에 따른 안전운행 방법을 교육한다.",
        isChecked: "",
      },
    ],
  },
];
